import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { MaterialImportsPage } from '../../features/material-imports/material-imports-page';

// breadcrumb ("Material Imports") and layout are inherited from the parent
// `/material-imports` layout route.
export const Route = createFileRoute('/material-imports/')({
  component: MaterialImportsRoute,
});

function MaterialImportsRoute() {
  const { t } = useTranslation('materials');
  const enabled = useFeatureFlag('bill_of_materials');

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">{t('notEnabled.title')}</h2>
        <p className="text-muted-foreground text-sm">{t('notEnabled.body')}</p>
      </div>
    );
  }

  return <MaterialImportsPage />;
}
